import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * AuthCallback
 * Handles the redirect from Emergent Google Auth.
 * URL fragment: #session_id=<id>
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH.
 */
const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { hydrateFromToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login', { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const res = await axios.post(`${API}/auth/google/session`, { session_id: sessionId });
        // Clean the fragment from the URL so refreshes are safe
        window.history.replaceState({}, document.title, window.location.pathname);
        await hydrateFromToken(res.data.token, res.data.user);
        toast.success('¡Bienvenido!');
        if (res.data.needs_onboarding) {
          navigate('/onboarding', { replace: true });
        } else {
          navigate('/dashboard', { replace: true });
        }
      } catch (err) {
        toast.error(err.response?.data?.detail || 'No se pudo completar el inicio de sesión con Google');
        navigate('/login', { replace: true });
      }
    })();
  }, [location.hash, navigate, hydrateFromToken]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto mb-4"></div>
        <p className="text-slate-600">Completando inicio de sesión con Google...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
